import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=6d93c5e0&"
import script from "./order-detail.js?vue&type=script&lang=js&"
export * from "./order-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports